import React from "react";
import appStyles from "../../../app.module.css";

const ErrorMsg = (props) => {
  // return <div className={appStyles.error}>{props.children}</div>;
  return <div className={appStyles.error} dangerouslySetInnerHTML={{ __html:props.children}}></div>;};

export default ErrorMsg;
